/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject } from 'react-router-dom';
import { HOME_ROUTE, mapRouteToRelativePath } from '../../util/routing';
import Activities from './pages/Activities';
import ActivityDetails from './pages/ActivityDetails';

export const ACTIVITIES_ROUTE_NAME = 'activities';
export const ACTIVITIES_ROUTE = mapRouteToRelativePath(ACTIVITIES_ROUTE_NAME);

export const activitiesRoutes: (isTfo: boolean) => RouteObject[] = (isTfo: boolean) => [
  {
    path: ACTIVITIES_ROUTE,
    element: isTfo ? <Activities /> : <Navigate to={HOME_ROUTE} replace />,
  },
  {
    path: `${ACTIVITIES_ROUTE}/:id`,
    element: isTfo ? <ActivityDetails /> : <Navigate to={HOME_ROUTE} replace />,
  },
];
